module.exports = __webpack_public_path__ + "static/media/check.11c72189.svg";